import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CouponPointsService } from '../../../services/index';

@Component({
    selector: 'add-edit-couponPoints-window',
    templateUrl: './addEditCouponPoints.component.html'
})
export class AddEditCouponPointsComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public couponPointsdata: any = {};

    isLoading: boolean = false;
    @Output() couponPointsLoadEvent = new EventEmitter();

    statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    constructor(private couponPointsService: CouponPointsService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#purchase_value').focus();
        }, 100);

        // Set default status if Add mode
        if (this.couponPointsdata.mode === 'Add') {
            this.couponPointsdata.status = 'Active';
        }

    }

    onSaveCouponPoints(): void {
        let that = this;
        this.isLoading = true;

        this.couponPointsService
            .addUpdateCouponPoints(this.couponPointsdata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.couponPointsLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/couponPoints/addEditCouponPoints.component.ts